import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';

import { Button } from '@feathr/components';

interface IDownloadLinkButtonProps {
  className?: string;
  href: string;
  label: string;
}

/** Downloads a file in a new tab. */
function DownloadLinkButton({
  className,
  href,
  label,
}: Readonly<IDownloadLinkButtonProps>): JSX.Element {
  return (
    <Button
      className={className}
      href={href}
      prefix={<FontAwesomeIcon icon={faDownload} size={'2x'} />}
      target={'_blank'}
    >
      {label}
    </Button>
  );
}

export default DownloadLinkButton;
